import { useEffect, useState } from 'react'
import { champsFromLeaderboard } from '../lib/groupTournaments'
import { fetchLeaderboardRankings } from '../services/tournamentService'
import BraggingRightsCard from './BraggingRightsCard'

// The group Prizes tab's default prizes (client 2026-10-12): every group
// tournament without a prize the owner added shows "Bragging Rights" here,
// the same card players see on the tournament's own Prizes tab.
export default function GroupBraggingRights({ groupId, tournaments }) {
  if (!tournaments || tournaments.length === 0) return null
  return (
    <div className="space-y-3">
      {tournaments.map((t) => (
        <BraggingRightsRow key={t.id} groupId={groupId} tournament={t} />
      ))}
    </div>
  )
}

// A finished tournament names its dub Champ(s), same lookup as the group
// page's tournament card.
function BraggingRightsRow({ groupId, tournament }) {
  const [champNames, setChampNames] = useState([])

  useEffect(() => {
    if (tournament.timing !== 'past') return undefined
    let cancelled = false
    fetchLeaderboardRankings({ groupId, tournamentId: tournament.id, limit: 5 })
      .then((rows) => {
        if (!cancelled) setChampNames(champsFromLeaderboard(rows).map((c) => c.full_name).filter(Boolean))
      })
      .catch((err) => console.error('Error loading group champ:', err))
    return () => { cancelled = true }
  }, [groupId, tournament.id, tournament.timing])

  return <BraggingRightsCard tournamentName={tournament.name} champNames={champNames} />
}
